import { consumptionAPI } from "./clients";
const ENDPOINT = `/entity_overview`;

/**
 * gets the overview data for the entity item
 * @param {Object} data
 * @param {String} data.entity_id Entity id of the item
 * @param {String} data.id Item id of the entity
 * @param {String} data.columns Columns to be fetched as part of the entity item
 * @param {String} data.page_id Used to paginate the event stream
 */
const getEntityOverview = ({
  entity_id,
  entity_item_id,
  columns,
  page_id,
  filters,
}) => {
  return consumptionAPI.post(ENDPOINT, {
    entity_id,
    entity_item_id,
    columns,
    page_id,
    filters,
  });
};

export { getEntityOverview };
